import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Container, Box, Tab, Card, Button, Typography, Tooltip, IconButton, Grid, TextField, FormControl, Stack, Link, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import './biddingSelection.css';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { authKey, UPLOAD_DCUMENT, DOWNLOAD_DOCUMENT, GET_BIDDING_SCHEDULE_SELECTION, RELEASE_SCHEDULES_SELECTION_FOR_BIDDING, APPROVE_REGULAR_SCHEDULES_FOR_BIDDING, RESCHEDULE_BIDDING, GET_APPROVED_STAKEHOLDERS } from "../../../common/URLs";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { t } from 'i18next';
import moment from 'moment';
import { FILE_NAME_VALIDATION_ERROR, PROD, allowedFileTypes } from "../../../common/constants";
import { toast } from "react-toastify";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { fileNameValidation } from "../../../common/commonValidations";
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { EditIcon, FileIcon, ViewIcon } from "../../../common/icons";
import { DesktopDatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import apiClient from "../../../axios";
import { FileUploadMUI } from "../../../common/fileUpload/fileUploadMUI";
import dayjs from 'dayjs';
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import TrashIcon from '../../../images/TrashIcon.png';

function BiddingSelection() {

    const [tabValue, setTabValue] = useState("Pending");
    const [biddingScheduleSelectionDetails, setBiddingScheduleSelectionDetails] = useState();
    const [releaseButtonDetails, setReleaseButtonDetails] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRequestNo, setSelectedRequestNo] = useState(null);
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [documentsArr, setDocumentsArr] = useState([]);
    const [selectedFile, setSelectedFile] = useState();
    const [fileuploadError, setFileuploadError] = useState('');
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [allotmentReqNo, setAllotmentReqNo] = useState('');
    const [updateStartTime, setUpdateStartTime] = useState(null);
    const [updateEndTime, setUpdateEndTime] = useState(null);
    const [decrementValue, setDecrementValue] = useState();
    const [editOpen, setEditOpen] = useState(false);
    const [urnList, setUrnList] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedTransporter, setSelectedTransporter] = useState([]);
     const [isApiCalled, setIsApiCalled] = useState(false);

    const [biddingDates, setBiddingDates] = useState({
        "biddingStartDate": null,
        "biddingEndDate": null,
        "biddingStartDateUpdated": null,
        "biddingEndDateUpdated": null
    })

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState({
        "biddingStartDateError": "",
        "biddingEndDateError": "",
        "biddingStartDateUpdatedError": "",
        "biddingEndDateUpdatedError": "",
        "startTimeError": "",
        "endTimeError": "",
        "updatestartTimeError": "",
        "updateendTimeError": "",
        "decrementValueError": "",
        "fileError": "",
    });

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    }

    const handleDateChange = (e, dateField) => {
        setBiddingDates({ ...biddingDates, [dateField]: e.format("YYYY-MM-DD") })
        if (dateField === "biddingStartDate") {
            setErrorMessage({ ...errorMessage, biddingStartDateError: "" });
        }
        if (dateField === "biddingEndDate") {
            setErrorMessage({ ...errorMessage, biddingEndDateError: "" });
        }
        if (dateField === "biddingStartDateUpdated") {
            setErrorMessage({ ...errorMessage, biddingStartDateUpdatedError: "" });
        }
        if (dateField === "biddingEndDateUpdated") {
            setErrorMessage({ ...errorMessage, biddingEndDateUpdatedError: "" });
        }
    }

    const handleStartTimeChange = (value) => {
        setStartTime(value);
        setErrorMessage({ ...errorMessage, startTimeError: "" });
    }

    const handleEndTimeChange = (value) => {
        setEndTime(value);
        setErrorMessage({ ...errorMessage, endTimeError: "" });
    }

    const handleSelectionModelChange = (newSelection) => {
        setSelectedRows(newSelection);
        const selectedId = newSelection[0];
        const selected = biddingScheduleSelectionDetails.find((row) => row.id === selectedId);
        setSelectedRequestNo(selected?.allotmentRequestNumber || null);
    };

    const handleTransporterSelection = (newSelection) => {
        let urn = []
        urnList.forEach(item => {
            if (newSelection.includes(item.urn)) {
                urn?.push({
                    "transporterUrn": item?.urn,
                    "transporterName": item?.name,
                    "transporterMobileNo": item?.mobileNo,
                    "transporterEmailId": item?.emailId
                })
            }
        })
        setSelectedTransporter(urn);
        setSelectionModel(newSelection);
    };

    const onDeleteFile = (e, item) => {
        e.preventDefault();
        const rows = [...documentsArr];
        const index = rows.findIndex((doc) => doc === item);
        if (index !== -1) {
            rows.splice(index, 1);
            setDocumentsArr(rows);
        }
    };

    useEffect(() => {
        if (selectedFile) {
            getDocumentUploadDetails();
        }
    }, [selectedFile]);

    useEffect(() => {
        if (documentUploadDetails) {
            let tempARR = documentsArr ? [...documentsArr] : []
            documentUploadDetails?.blobResponse && tempARR.push(documentUploadDetails?.blobResponse);
            setDocumentsArr(tempARR);
        }
    }, [documentUploadDetails]);

    const uploadDocument = (e, type) => {
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setFileuploadError('The file should be less than 5MB');
            setSelectedFile();
        }
        else if (e.target.files[0].name.split('.').length > 2) {
            setFileuploadError("Double extension file detected");
            setSelectedFile();
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setFileuploadError(FILE_NAME_VALIDATION_ERROR);
            setSelectedFile();
        }
        else {
            setSelectedFile(e.target.files[0]);
            setFileuploadError('');
        }
    };

    function getDocumentUploadDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "pit");
        apiClient
            .post(
                UPLOAD_DCUMENT,
                formData,
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                setDocumentUploadDetails(response.data);
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const onViewDetails = (row) => {
        navigate('./biddingDetails', {
            state: { selectedRow: row, page: "biddingSelection" }
        });
    }

    const onEditBidding = (row) => {
        setEditOpen(true);
        setAllotmentReqNo(row?.allotmentRequestNumber);
        setBiddingDates({ ...biddingDates, "biddingStartDateUpdated": moment(row?.biddingStartDate).format("YYYY-MM-DD"), "biddingEndDateUpdated": moment(row?.biddingEndDate).format("YYYY-MM-DD") })
        setUpdateStartTime(dayjs(row?.biddingStartTime, "HH:mm:ss"));
        setUpdateEndTime(dayjs(row?.biddingEndTime, "HH:mm:ss"));
    }

    const handleUpdateStartTimeChange = (value) => {
        setUpdateStartTime(value);
        setErrorMessage({ ...errorMessage, updatestartTimeError: "" });
    }

    const handleUpdateEndTimeChange = (value) => {
        setUpdateEndTime(value);
        setErrorMessage({ ...errorMessage, updateendTimeError: "" });
    }

    const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
        loaderService.showLoader();
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": documentBlobName,
                    "containerName": "pit",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                if (type === "View") {
                    const fileName = finalfileName
                    const splittedName = fileName.split('.')
                    const fileExtension = splittedName[splittedName.length - 1];
                    let fileType;
                    switch (fileExtension) {
                        case 'pdf':
                            fileType = 'application/pdf';
                            break;
                        case 'png':
                            fileType = 'image/png';
                            break;
                        case 'jpg':
                            fileType = 'image/jpeg';
                            break;
                        case 'jpeg':
                            fileType = 'image/jpeg';
                            break;
                        default:
                            fileType = 'application/octet-stream';
                    }
                    const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                    const newWindow = window.open(url, '_blank');
                    newWindow.focus();
                }
                else {
                    const a = document.createElement("a");
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = finalfileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const columns = [
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
        },
        {
            field: 'allotmentQuantity', headerName: 'Quantity(MT)', type: 'number', width: 150,
            valueGetter: params => params?.value?.toFixed(2),
        },
        { field: 'firstPartyLocationAddress', headerName: 'Origin', width: 230 },
        { field: 'secondPartyLocationAddress', headerName: 'Destination', width: 230 },
        {
            field: 'materialType', headerName: 'Material Type', width: 140,
            valueFormatter: (params) => {
                if (params.value === 'CB') {
                    return 'Chipped bamboo';
                }
                else if (params.value === 'RB') {
                    return 'Raw bamboo';
                }
            }
        },

        {
            field: 'baseBidPrice', headerName: 'Base Rate(per ton per KM)', type: 'number', width: 200,
            valueGetter: params => params?.value?.toFixed(2)
        },
        {
            field: 'view', headerName: 'Action', width: 180,
            renderCell: (params) => (
                <>
                    {/* <Tooltip title="View Document">
                        <IconButton color="primary" sx={{ minWidth: 70 }} variant="contained" disabled={params?.row?.biddingTermsFileId === null} onClick={(e) => viewdownloadDocument(params?.row?.biddingTermsFileId, params?.row?.biddingTermsFileName, "Download")} >{params?.row?.biddingTermsFileId === null ? "" : <FileIcon />}</IconButton>
                    </Tooltip> */}
                    <Tooltip title="View Details">
                        <IconButton color="primary" sx={{ minWidth: 70 }} onClick={() => onViewDetails(params?.row)}><ViewIcon /></IconButton>
                    </Tooltip>
                </>

            )
        },
    ]

    const approvedCol = [
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
        },
        {
            field: 'allotmentQuantity', headerName: 'Quantity(MT)', type: 'number', width: 180,
            valueGetter: params => params?.value?.toFixed(2),
        },
        { field: 'firstPartyLocationAddress', headerName: 'Origin', width: 230 },
        { field: 'secondPartyLocationAddress', headerName: 'Destination', width: 240 },
        {
            field: 'materialType', headerName: 'Materila Type', width: 140,
            valueFormatter: (params) => {
                if (params.value === 'CB') {
                    return 'Chipped bamboo';
                }
                else if (params.value === 'RB') {
                    return 'Raw bamboo';
                }
            }
        },

        {
            field: 'baseBidPrice', headerName: 'Base Rate(per ton per KM)', type: 'number', width: 200,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'decrementValue', headerName: 'Decrement Value', type: 'number', width: 160,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'biddingStartDate', headerName: 'Bidding Start Date', width: 150,
            valueFormatter: params => params.value !== null ? moment(params?.value).format("DD/MM/YYYY") : "",
        },
        {
            field: 'biddingEndDate', headerName: 'Bidding End Date', width: 150,
            valueFormatter: params => params.value !== null ? moment(params?.value).format("DD/MM/YYYY") : "",
        },
        {
            field: 'biddingStartTime', headerName: 'Bidding Start Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }
        },
        {
            field: 'biddingEndTime', headerName: 'Bidding End Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }

        },
        {
            field: 'bidDocumentList',
            headerName: 'Documents',
            width: 300,
            renderCell: (params) => {
                const docs = params.value || [];
                if (docs.length === 0) return "No files";
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {docs.map((doc) => (
                            <Link
                                // key={index}
                                onClick={(e) => viewdownloadDocument(doc?.biddingTermsFileId, doc?.biddingTermsFileName, "Download")}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                {doc.biddingTermsFileName}
                            </Link>
                        ))}
                    </div>
                );
            }
        },
        {
            field: 'action', headerName: 'Action', width: 180,
            renderCell: (params) => {
                // Extract date in YYYY-MM-DD format only
                const datePart = String(params.row.biddingStartDate).slice(0, 10); // e.g. "2025-06-26"
                const timePart = String(params.row.biddingStartTime || "00:00:00"); // e.g. "13:46:00"
                const startDateTime = moment(`${datePart} ${timePart}`, "YYYY-MM-DD HH:mm:ss", true);
                const now = moment();
                const isFuture = startDateTime.isValid() && startDateTime.isAfter(now);
                // disabled={!isFuture}
                return (<>
                    <Tooltip title="Edit">
                        <IconButton color="primary" sx={{ minWidth: 70 }} variant="contained" onClick={() => onEditBidding(params?.row)} >{<EditIcon />}</IconButton>
                    </Tooltip>
                    <Tooltip title="View Details">
                        <IconButton color="primary" sx={{ minWidth: 70 }} onClick={() => onViewDetails(params?.row)}><ViewIcon /></IconButton>
                    </Tooltip>
                </>)

            }
        },

    ]

    const transporterCol = [
        { field: 'urn', headerName: 'URN', flex: 1 },
        { field: 'name', headerName: 'Name', flex: 1 },
        { field: 'mobileNo', headerName: 'Mobile Number', flex: 1 },
        { field: 'emailId', headerName: 'Email', flex: 1 },
    ]

    useEffect(() => {
        getBiddingScheduleSelection();
    }, [tabValue]);

    const getBiddingScheduleSelection = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_BIDDING_SCHEDULE_SELECTION,
                {
                    "type": tabValue
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setBiddingScheduleSelectionDetails(response.data.spotBiddingAllotmentRequestDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    // const onConfirmApprove = (e) => {
    //     handleConfirmClose();
    //     onReleaseButton(e);
    // }

    const onConfirmApprove = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onReleaseButton();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    };

    const release = (e) => {
        if (!biddingDates?.biddingStartDate) {
            setErrorMessage({ ...errorMessage, biddingStartDateError: "Please Select Bidding Start Date" })
        }
        else if (!biddingDates?.biddingEndDate) {
            setErrorMessage({ ...errorMessage, biddingEndDateError: "Please Select Bidding End Date" })
        }
        else if (!startTime) {
            setErrorMessage({ ...errorMessage, startTimeError: "Please Select Start Time" })
        }
        else if (!endTime) {
            setErrorMessage({ ...errorMessage, endTimeError: "Please Select End Time" })
        }
        else if (!decrementValue) {
            setErrorMessage({ ...errorMessage, decrementValueError: "Please Enter Decrement Value" })
        }
        else if (documentsArr?.length === 0) {
            setFileuploadError("Please Upload Bidding Terms Document")
        }
        else if (selectedTransporter?.length === 0) {
            toast.error("Please select Transporters")
        }
        else handleConfirmOpen();
    }

    const formatTime = (value) =>
        value ? dayjs(value).format('HH:mm:') + '000' : '';

    const onReleaseButton = () => {
        const tempArr = [];
        documentsArr.map((item) => {
            tempArr.push({
                "biddingTermsFileId": item?.blobFileName,
                "biddingTermsFileName": item?.fileName,
                "containerName": "pit",
            })
        });
        loaderService.showLoader();
        apiClient
            .post(
                RELEASE_SCHEDULES_SELECTION_FOR_BIDDING,
                {
                    "allotmentRequestNumber": selectedRequestNo,
                    "biddingStartDate": biddingDates?.biddingStartDate,
                    "biddingStartTime": formatTime(startTime),
                    "biddingEndDate": biddingDates?.biddingEndDate,
                    "biddingEndTime": formatTime(endTime),
                    "decrementValue": decrementValue,
                    "bidDocumentList": tempArr,
                    "biddingTransporters": selectedTransporter
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            ).then((response) => {
                setReleaseButtonDetails(response.data);
                getBiddingScheduleSelection();
                setBiddingDates({
                    "biddingStartDate": null,
                    "biddingEndDate": null
                })
                setStartTime(null);
                setEndTime(null);
                setDecrementValue('');
                setDocumentsArr([]);
                setSelectedTransporter([]);
                setSelectionModel([]);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });

    };


    useEffect(() => {
        if (releaseButtonDetails) {
            if (releaseButtonDetails.isSuccess === true) {
                toast.success("Successfully released for Bidding")
            } else {
                toast.error(releaseButtonDetails?.message ? releaseButtonDetails?.message : "Error")
            }
        }
    }, [releaseButtonDetails]);

    const onDecrementValueChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            setDecrementValue(value);
        }
        setErrorMessage({ ...errorMessage, decrementValueError: "" });
    }
    const handleClose = () => {
        setEditOpen(false);
    };

    const onSubmitClick = (e) => {
        if (!biddingDates?.biddingStartDateUpdated) {
            setErrorMessage({ ...errorMessage, biddingStartDateError: "Please Select Bidding Start Date" })
        }
        else if (!biddingDates?.biddingEndDateUpdated) {
            setErrorMessage({ ...errorMessage, biddingEndDateUpdatedError: "Please Select Bidding End Date" })
        }
        else if (!updateStartTime) {
            setErrorMessage({ ...errorMessage, updatestartTimeError: "Please Select Start Time" })
        }
        else if (!updateEndTime) {
            setErrorMessage({ ...errorMessage, updateendTimeError: "Please Select End Time" })
        }
        else {
            handleConfirmOpen2();
        }

    }

    // const onConfirmSubmit = (e) => {
    //     handleConfirmClose2();
    //     rescheduleBidding(e);
    // }

    
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await rescheduleBidding();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen2(false);
            setIsApiCalled(false);
        }
    };

    const rescheduleBidding = () => {
        loaderService.showLoader();
        apiClient
            .post(
                RESCHEDULE_BIDDING,
                {
                    "allotmentRequestNumber": allotmentReqNo,
                    "biddingStartDate": biddingDates?.biddingStartDateUpdated,
                    "biddingStartTime": formatTime(updateStartTime),
                    "biddingEndDate": biddingDates?.biddingEndDateUpdated,
                    "biddingEndTime": formatTime(updateEndTime)
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            ).then((response) => {
                if (response.data.isSuccess === true) {
                    toast.success(response.data.message);
                    setEditOpen(false);
                    setAllotmentReqNo('');
                    setBiddingDates({
                        "biddingStartDateUpdated": null,
                        "biddingEndDateUpdated": null
                    });
                    setUpdateStartTime(null);
                    setUpdateEndTime(null);
                    getBiddingScheduleSelection();
                }
                else {
                    toast.error(response.data.message);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        onStakeholderTypeChange();
    }, []);

    const onStakeholderTypeChange = () => {
        loaderService.showLoader();
        apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                "type": "Transporter"
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setUrnList(response.data.stakeHolders);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    return (
        <>
            <Container maxWidth="xxl">
                <Typography variant="h4" gutterBottom>
                    Release Allotment Request
                </Typography>
                <Card>
                    <TabContext value={tabValue} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                <Tab label="Bidding Requests for Release" value="Pending" />
                                <Tab label="Released Bidding Requests" value="Approve" />
                            </TabList>
                        </Box>
                        <TabPanel value="Pending">
                            <Grid container spacing={3}>
                                <Grid item xs={12} lg={12}>
                                    <Box sx={{ height: 400, width: '100%' }}>

                                        {
                                            biddingScheduleSelectionDetails &&
                                            <DataGrid
                                                getRowHeight={() => 'auto'}
                                                rows={biddingScheduleSelectionDetails}
                                                columns={columns}
                                                pageSize={10}
                                                rowsPerPageOptions={[10]}
                                                components={{ Toolbar: QuickSearchToolbar }}
                                                checkboxSelection
                                                selectionModel={selectedRows}
                                                onSelectionModelChange={handleSelectionModelChange}
                                                isRowSelectable={(params) => {
                                                    return selectedRows.length === 0 || selectedRows.includes(params.id);
                                                }}
                                            />
                                        }
                                    </Box>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <FormControl fullWidth >
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <div style={{ display: 'flex', gap: '16px' }}>
                                                <DesktopDatePicker
                                                    label="Bidding Start Date"
                                                    inputFormat="DD/MM/YYYY"
                                                    name="biddingStartDate"
                                                    value={biddingDates.biddingStartDate}
                                                    onChange={(e) => { handleDateChange(e, "biddingStartDate") }}
                                                    renderInput={(params) => <TextField fullWidth {...params} error={errorMessage.biddingStartDateError} helperText={errorMessage.biddingStartDateError} />}
                                                />
                                                <DesktopDatePicker
                                                    label="Bidding End Date"
                                                    inputFormat="DD/MM/YYYY"
                                                    name="biddingEndDate"
                                                    value={biddingDates.biddingEndDate}
                                                    onChange={(e) => { handleDateChange(e, "biddingEndDate") }}
                                                    renderInput={(params) => <TextField fullWidth {...params} error={errorMessage.biddingEndDateError} helperText={errorMessage.biddingEndDateError} />}
                                                />
                                            </div>
                                        </LocalizationProvider>

                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} lg={6}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <div style={{ display: 'flex', gap: '16px' }}>
                                            <TimePicker
                                                label="Bidding Start Time"
                                                name="biddingStartTime"
                                                value={startTime}
                                                onChange={(newValue) => handleStartTimeChange(newValue)}
                                                renderInput={(params) => <TextField fullWidth {...params} error={errorMessage.startTimeError} helperText={errorMessage.startTimeError} />}
                                            />
                                            <TimePicker
                                                label="Bidding End Time"
                                                name="biddingEndTime"
                                                value={endTime}
                                                onChange={(newValue) => handleEndTimeChange(newValue)}
                                                renderInput={(params) => <TextField fullWidth {...params} error={errorMessage.endTimeError} helperText={errorMessage.endTimeError} />}
                                            />
                                        </div>
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth required
                                        error={errorMessage.decrementValueError}
                                        helperText={errorMessage.decrementValueError}
                                        type="number"
                                        onFocus={handleNumberFieldFocus}
                                        label="Decrement Value"
                                        value={decrementValue || ''}
                                        inputProps={{ step: '0.01' }}
                                        onChange={(e) => onDecrementValueChange(e)}
                                        onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                                    />
                                </Grid>
                                {/* <Grid item xs={12} lg={6}>
                                    <FileUploadMUI key="biddingTermsFile"
                                        documentList={documentsArray}
                                        documentType="biddingTermsFile"
                                        callBackDocumentUpload={onUploadCallBack}
                                        title="Upload Bidding Terms Document"
                                        containerName="pit"
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        documentError="fileError"
                                    />
                                </Grid> */}
                                <Grid item xs={12} lg={12}>
                                    <div className='row-flex'>
                                        <label className="view-file-link-common">
                                            <input
                                                style={{ display: "none" }}
                                                type="file"
                                                accept="image/jpeg, image/jpg, image/png, .pdf"
                                                name="photo"
                                                onChange={(e) => uploadDocument(e)}
                                            />Upload File
                                        </label>
                                        {documentsArr?.map((item, index) => {
                                            return (
                                                <div style={{ display: "flex", flexDirection: "row", marginLeft: '1vh' }} className='view-file-name-common'>
                                                    {item?.fileName}
                                                    <img src={TrashIcon} style={{ cursor: "pointer", marginLeft: "2vh", height: "3vh" }} alt="TrashIcon" onClick={(e) => onDeleteFile(e, item)} />
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <Typography style={{ marginLeft: "3vh" }} variant="subtitle2" fontSize="1.8vh" align="left" color="green">{t('preReg.uploadFileTypeNote')}</Typography>
                                    <div className='resource-knowledge-error-message' >{fileuploadError}</div>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Box sx={{ height: 400, width: '100%' }}>
                                        <DataGrid
                                            getRowHeight={() => 'auto'}
                                            rows={urnList}
                                            columns={transporterCol}
                                            pageSize={10}
                                            getRowId={(row) => row?.urn}
                                            rowsPerPageOptions={[10]}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                            checkboxSelection
                                            selectionModel={selectionModel}
                                            onSelectionModelChange={handleTransporterSelection}
                                        // isRowSelectable={(params) => {
                                        //     return selectedRows.length === 0 || selectedRows.includes(params.id);
                                        // }}
                                        />
                                    </Box>

                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Button style={{ float: "right" }} variant="contained" hidden={tabValue === "approve"} disabled={selectedRows?.length < 1} onClick={() => release()} startIcon={<ApproveIcon />}>Release for Bidding</Button>
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value="Approve">
                            <Box sx={{ height: 450, width: '100%' }}>
                                {
                                    biddingScheduleSelectionDetails &&
                                    <DataGrid
                                        getRowHeight={() => 'auto'}
                                        rows={biddingScheduleSelectionDetails}
                                        columns={approvedCol}
                                        pageSize={10}
                                        rowsPerPageOptions={[10]}
                                        components={{ Toolbar: QuickSearchToolbar }} />
                                }
                            </Box>
                            <Dialog maxWidth='md'
                                open={editOpen}
                                onClose={handleClose}>
                                <DialogTitle>Rescheduling of Allotment Request</DialogTitle>
                                <DialogContent>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} lg={12} mt={1}>
                                            <FormControl fullWidth >
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <div style={{ display: 'flex', gap: '16px' }}>
                                                        <DesktopDatePicker
                                                            label="Bidding Start Date"
                                                            inputFormat="DD/MM/YYYY"
                                                            name="biddingStartDateUpdated"
                                                            value={biddingDates.biddingStartDateUpdated}
                                                            onChange={(e) => { handleDateChange(e, "biddingStartDateUpdated") }}
                                                            renderInput={(params) => <TextField fullWidth {...params} error={errorMessage.biddingStartDateUpdatedError} helperText={errorMessage.biddingStartDateError} />}
                                                        />
                                                        <DesktopDatePicker
                                                            label="Bidding End Date"
                                                            inputFormat="DD/MM/YYYY"
                                                            name="biddingEndDateUpdated"
                                                            value={biddingDates.biddingEndDateUpdated}
                                                            onChange={(e) => { handleDateChange(e, "biddingEndDateUpdated") }}
                                                            renderInput={(params) => <TextField fullWidth {...params} error={errorMessage.biddingEndDateUpdatedError} helperText={errorMessage.biddingEndDateError} />}
                                                        />
                                                    </div>
                                                </LocalizationProvider>

                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} lg={12}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <div style={{ display: 'flex', gap: '16px' }}>
                                                    <TimePicker
                                                        label="Bidding Start Time"
                                                        name="biddingStartTime"
                                                        value={updateStartTime}
                                                        onChange={(newValue) => handleUpdateStartTimeChange(newValue)}
                                                        renderInput={(params) => <TextField fullWidth {...params} error={errorMessage.updatestartTimeError} helperText={errorMessage.updatestartTimeError} />}
                                                    />
                                                    <TimePicker
                                                        label="Bidding End Time"
                                                        name="biddingEndTime"
                                                        value={updateEndTime}
                                                        onChange={(newValue) => handleUpdateEndTimeChange(newValue)}
                                                        renderInput={(params) => <TextField fullWidth {...params} error={errorMessage.updateendTimeError} helperText={errorMessage.updateendTimeError} />}
                                                    />
                                                </div>
                                            </LocalizationProvider>
                                        </Grid>

                                    </Grid>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={(e) => handleClose(e)} >Cancel</Button>
                                    <Button onClick={(e) => onSubmitClick(e)}>Submit</Button>
                                </DialogActions>
                            </Dialog>
                        </TabPanel>
                    </TabContext>
                </Card >

            </Container >
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Release for Bidding" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmSubmit} onClose={handleConfirmClose2} action="Submit" />
        </>
    )
}
export default BiddingSelection;